import { ErrorBoundary } from '@sentry/react';
import { Loader, Typography } from '@statsbomb/kitbag-components';
import { ReactNode, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const HomeSectionError = () => {
  const { t } = useTranslation('home');
  return <Typography variant="bodyRegular">{t('sectionError')}</Typography>;
};

// The div stops a child column Stacked (height: 100%) from stretching to the page height.
export const HomeSection = ({ children, fallback = <Loader /> }: { children: ReactNode; fallback?: ReactNode }) => (
  <div>
    <ErrorBoundary fallback={<HomeSectionError />}>
      <Suspense fallback={fallback}>{children}</Suspense>
    </ErrorBoundary>
  </div>
);
